import React from 'react';
import { useParams } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { ExternalRedirect } from '../components/ExternalRedirect';
import { AppointmentAside } from '../components/AppointmentAside';
import { TreatmentList } from '../components/TreatmentList';
import { NotFound } from './NotFound';
import { complaints } from '../data/complaints';
import { treatments } from '../data/treatments';
export function ComplaintDetail() {
  const {
    slug
  } = useParams();
  const complaint = complaints.find(c => c.slug === slug);
  if (!complaint) return <NotFound data-id="element-401" data-mp="1yeynrxexg11y" />;
  if (complaint.page) return <ExternalRedirect to={complaint.page} data-id="element-402" data-mp="1ydx9zl6j10gj" />;
  const related = complaint.treatmentSlugs.map(s => treatments.find(t => t.slug === s)).filter((t): t is NonNullable<typeof t> => Boolean(t));
  return <>
      <PageHeader title={complaint.title} crumbs={[{
      label: 'Pijnklachten',
      to: '/pijnbehandelingen'
    }, {
      label: complaint.title
    }]} data-id="element-403" data-mp="43a7nrwylsfz" />

      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-14 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-20" data-id="element-404" data-mp="zc8prmz00thx">
        <div className="lg:col-span-8" data-id="element-405" data-mp="14b239feacki3">
          <img src={complaint.image} alt="" className="aspect-[16/7] w-full rounded-3xl object-cover" data-id="element-406" data-mp="147xqhtmr8gft" />
          <div className="mt-10 space-y-4 text-lg leading-relaxed text-muted" data-id="element-407" data-mp="1e03i3293gvuh">
            {complaint.description.map(p => <p key={p} data-id="element-408" data-mp="1izy8l4oyjjf0">{p}</p>)}
          </div>

          <section className="mt-14" data-id="element-409" data-mp="1j1j2cs3g6ybt">
            <h2 className="font-display text-2xl font-semibold text-ink" data-id="element-410" data-mp="1n00b1g2iogvc">Behandelingen</h2>
            <p className="mt-2 text-[15px] text-muted" data-id="element-411" data-mp="1rzd0m8krw21m">
              Tijdens de intake bepaalt de pijnspecialist samen met u welke behandeling bij u past.
            </p>
            <div className="mt-6" data-id="element-412" data-mp="1wwlfo0amjpyn">
              <TreatmentList treatments={related} data-id="element-413" data-mp="3ts17crwml7m5" />
            </div>
          </section>
        </div>

        <div className="lg:col-span-4" data-id="element-414" data-mp="2k56orqg1xq3">
          <AppointmentAside data-id="element-415" data-mp="2n114633249s" />
        </div>
      </div>
    </>;
}